module.exports = __webpack_public_path__ + "media/images/patient-icons/appointment-icon-572a0cabda82c786afae016d3332955d.svg";